<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">
        <el-row :span="24">

          <el-col :span="12">
            <el-form-item prop="title" label="标题">
              <el-input clearable v-model="formData.title" placeholder="请输入标题" />

            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="amount" label="费用（元）">
              <!-- <el-input clearable v-model="formData.amount" placeholder="请输入费用" /> -->
              <el-input-number  v-model="formData.amount"  placeholder="请输入费用（元）"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="12">

            <el-form-item prop="expenseDate" label="费用发生日期">
              <el-date-picker v-model="formData.expenseDate" placeholder="请选择费用发生日期" type="date" clearable
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

          </el-col>

        </el-row>
        <el-row :span="24">
          <el-col :span="24">

            <el-form-item prop="description" label="说明">
              <el-input type="textarea" :rows="4" placeholder="请输入说明" v-model="formData.description">
              </el-input>
            </el-form-item>

          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap">

                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <i class="el-icon-error close-icon" @click="delImage(formData.fileList.indexOf(item))"></i>
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>

                <el-upload class="upload-demo" :show-file-list="false" :action="$apis.common.uploadUrl"
                  :on-success="handleSuccess" :before-upload="beforeUpload" list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    图片大小不能超过10MB~
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'ExpenseManageAdd',

  data () {
    return {
      formData: {

        title: '',
        amount: undefined,
        description: '',
        expenseDate: '',
        fileList: []
      },

      rules: {
        expenseDate: [
          {
            required: true,
            message: '请选择费用发生日期',
            trigger: ['blur', 'change']
          }
        ],
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: ['blur', 'change']
          }
        ],
        amount: [
          {
            required: true,
            message: '请输入费用（元）',
            trigger: ['blur', 'change']
          }
        ]

      },
      loading: false,
      userList: []

    }
  },
  created () {
    if (this.expenseId) {
      this.loadData()
    }
  },
  computed: {
    expenseId () {
      return this.$route.query.expenseId
    },

    fileImgUrl () {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.expenseManage.selectPaExpenseRecordByExpenseId, {
          params: { expenseId: this.expenseId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleSuccess (res) {
      this.formData.fileList.push(res.data)
    },
    delImage (index) {
      this.formData.fileList.splice(index, 1)
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.expenseManage.insertPaExpenseRecord
          if (this.expenseId) {
            url = this.$apis.expenseManage.updatePaExpenseRecord
          }

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
